import { render, staticRenderFns } from "./NoContentFatura.vue?vue&type=template&id=3a26072c&"
import script from "./NoContentFatura.vue?vue&type=script&lang=js&"
export * from "./NoContentFatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports